<div class="d-flex align-items-center flex-column cursor-pointer item-wrapper">

  <div class="image">
    <img [src]="template.templateMetadata?.imageUrl" alt=""/>
  </div>

  <div class="title text-center mt-2">{{template.name}}</div>
</div>
